import { executeStandardRequest, type MusinsaStandardResponse } from '@musinsa/packages-http';
import { privateHttpClient } from '../httpClient';
import { mypageQueryKeys } from './queryKeys';

/** OpenAPI `Event` — 큐레이터 마이페이지 이벤트 목록 항목 */
export type CuratorEventItem = {
  image: string;
  label: string;
  title: string;
  displayPeriod: string;
  link: string;
  sourceType: string;
  eventType: string;
  remainingDays: number;
};

export type GetCuratorEventsData = {
  events: CuratorEventItem[];
};

export type GetCuratorEventsResponse = MusinsaStandardResponse<GetCuratorEventsData>;

export const getCuratorEvents = async () =>
  executeStandardRequest(() =>
    privateHttpClient.get<GetCuratorEventsResponse>(mypageQueryKeys.getEvents),
  );
